var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import React from 'react';
import MuiTablePagination from '@material-ui/core/TablePagination';
import { DownCaretIcon } from '../Icon';
var StyledDownCaretIcon = styled(DownCaretIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    position: absolute;\n    right: 0.4rem;\n  }\n"], ["\n  && {\n    position: absolute;\n    right: 0.4rem;\n  }\n"])));
/**
 * Kareo wrapped component of the Material-UI TablePagination. The prop API has been limited to props defined in TablePaginationProps.
 *
 * The TablePagination component enables the user to select a specific page from a range of pages.
 *
 * Material-UI TablePagination: [Docs](https://v4.mui.com/components/table-pagination/), [API](https://v4.mui.com/api/table-pagination/)
 *
 * @storybook: [TablePagination](http://design.kareoprod.ent/design-system/?path=/story/components-data-display--table-pagination)
 */
var TablePagination = React.forwardRef(function (props, ref) {
    return (React.createElement(MuiTablePagination, __assign({}, props, { SelectProps: {
            IconComponent: function () { return React.createElement(StyledDownCaretIcon, { fontSize: "xxsmall" }); },
        }, "data-testid": "table-pagination", ref: ref })));
});
TablePagination.defaultProps = {};
TablePagination.displayName = 'KareoTablePagination';
export default TablePagination;
var templateObject_1;
